/* Syncs the pressed/active state of every [data-hdt-wishlist-toggle] button
   on the page (product cards, etc.) with window.HdtWishlist (see
   header-plus-ultra.js), which owns the actual click-to-toggle handler and
   localStorage persistence. */
(function () {
  function sync() {
    if (!window.HdtWishlist) return;
    document.querySelectorAll('[data-hdt-wishlist-toggle]').forEach((toggle) => {
      const isActive = window.HdtWishlist.has(toggle.getAttribute('data-hdt-wishlist-toggle'));
      toggle.classList.toggle('is-active', isActive);
      toggle.setAttribute('aria-pressed', String(isActive));
    });
  }

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('hdt:wishlist:updated', sync);
  if (document.readyState === 'complete' || document.readyState === 'interactive') sync();
})();
